/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

export interface UpArrowIconProps {
  color?: string;
  size?: IconSize;
}
/*
 * Defines the Design Language System (DLS) Up Arrow Icon component.
 */
export const UpArrowIcon = ({size = IconSize.small, color = dlsColor('aaBlue')}: UpArrowIconProps) => {
  const {iconSize} = useIconDLS({size});
  return (
    <ThemeIconProvider name='UpArrowIcon' size={size} color={color} legacyIcon={(
      <svg width={18} height={26} viewBox="0 0 15 23" fill={'none'}>
        <path xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" d="M7.50025 22.4375C7.70745 22.4375 7.90617 22.3552 8.05268 22.2087C8.19919 22.0622 8.2815 21.8635 8.2815 21.6563V3.22969L13.1971 8.14688C13.3438 8.29357 13.5428 8.37599 13.7503 8.37599C13.9577 8.37599 14.1567 8.29357 14.3034 8.14688C14.4501 8.00018 14.5325 7.80121 14.5325 7.59375C14.5325 7.38629 14.4501 7.18732 14.3034 7.04063L8.05338 0.790627C7.98081 0.717871 7.89459 0.660149 7.79968 0.620764C7.70477 0.581379 7.60301 0.561106 7.50025 0.561106C7.39749 0.561106 7.29574 0.581379 7.20083 0.620764C7.10591 0.660149 7.0197 0.717871 6.94713 0.790627L0.697129 7.04063C0.550431 7.18732 0.468018 7.38629 0.468018 7.59375C0.468018 7.80121 0.550431 8.00018 0.697129 8.14688C0.843827 8.29357 1.04279 8.37599 1.25025 8.37599C1.45772 8.37599 1.65668 8.29357 1.80338 8.14688L6.719 3.22969V21.6563C6.719 21.8635 6.80131 22.0622 6.94783 22.2087C7.09434 22.3552 7.29305 22.4375 7.50025 22.4375Z" fill={color}/>
      </svg>
    )} />
  );
};
